/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".answer[_ngcontent-%COMP%]{margin-top:10px;width:100%}.answer[_ngcontent-%COMP%]   textarea[_ngcontent-%COMP%]{height:320px}mat-slide-toggle[_ngcontent-%COMP%]{margin-left:10px;margin-top:5px}"];
export { styles as styles };
